/**
 * This module exports some utilities pertaining to property openFilter. That is, openFilter that can be applied on properties like price range, star rating etc...
 * Currently, this is only used on the map module.
 */

import {
  MapPropertySearchById,
  PropertySearchFiltersInput,
  StarRangeInput,
  PriceRangeInput
} from "__generated__/api";
import { Filter } from "uitk-react-experimental-module-map";
import { StructureType } from "__generated__/api/types";
import _Options = MapPropertySearchById._Options;
import { PropertyFilterType } from "src/model/PropertyFilter";

/**
 * Represents openFilter that we show to our users.
 */
export const supportedFiltersName: string[] = ["price", "star", "lodging"];

export function isFilterSupported(filterName: string): boolean {
  return supportedFiltersName.includes(filterName);
}

export function convertClassOptionValue(value: string): number {
  return Number(value) / 10;
}

export function isValidBexApiFilterOption(bexApiFilterOption: _Options): boolean {
  return (
    bexApiFilterOption.label !== null &&
    typeof bexApiFilterOption.label !== "undefined" &&
    bexApiFilterOption.value !== null &&
    typeof bexApiFilterOption.value !== "undefined"
  );
}

export function filterOptionHasValidRange(bexApiFilterOption: _Options): boolean {
  return bexApiFilterOption.range !== null && typeof bexApiFilterOption.range !== "undefined";
}

export function filterIsEnabled(filter: Filter) {
  for (const opt of filter.options) {
    if (opt.isSelected === true) {
      return true;
    }
  }

  return false;
}

//TODO revisit with visitor pattern possibly.
export function constructBexApiPropertyFilter(
  bexApiFilter: PropertySearchFiltersInput,
  propertyFilters: Filter[]
) {
  propertyFilters.forEach(propertyFilter => {
    if (filterIsEnabled(propertyFilter)) {
      switch (propertyFilter.type) {
        case PropertyFilterType.PRICE: {
          bexApiFilter.price = getBexApiPropertyFilterPriceType(propertyFilter);
          break;
        }
        case PropertyFilterType.CLASS: {
          bexApiFilter.stars = getBexApiPropertyFilterClassType(propertyFilter);
          break;
        }
        case PropertyFilterType.LODGING: {
          bexApiFilter.structureTypes = getBexApiPropertyFilterStructureType(propertyFilter);
          break;
        }
      }
    }
  });
}

function getBexApiPropertyFilterClassType(filter: Filter): StarRangeInput {
  const enabledClassOptions = filter.options.filter(option => option.isSelected);
  enabledClassOptions.sort(
    (option1, option2) => (option1.value as number) - (option2.value as number)
  );
  const minStars = Number(enabledClassOptions[0].value);
  const maxStars = Number(enabledClassOptions[enabledClassOptions.length - 1].value);

  return { min: minStars || 0, max: maxStars || 0 };
}

function getBexApiPropertyFilterPriceType(filter: Filter): PriceRangeInput {
  const enabledPriceOptions = filter.options.filter(option => option.isSelected);
  enabledPriceOptions.sort(
    (option1, option2) => (option1.value as number) - (option2.value as number)
  );
  const minPrice = enabledPriceOptions[0].range!.min;
  const maxPrice = enabledPriceOptions[enabledPriceOptions.length - 1].range!.max;

  return { min: minPrice || 0, max: maxPrice || 0 };
}

function getBexApiPropertyFilterStructureType(filter: Filter): StructureType[] {
  const enabledStructuredOptions = filter.options.filter(option => option.isSelected);

  return enabledStructuredOptions.map(enabledOption => StructureType[enabledOption.enumValue!]);
}
